import * as PIXI from "pixi.js-legacy";
import { injectable, inject } from 'inversify';
import SERVICE_IDENTIFIER from '../../framework/src/constants/identifiers';
import PixiAudio from '../../framework/src/engine/pixi/PixiAudio';
import GameSlotsCore from '../../framework/src/game/GameSlotsCore';
import SystemConfig from '../../framework/src/system/SystemConfig';
import Wallet from '../../framework/src/wallet/Wallet';
import GAME_PARTS from '../identifiers';
import WinController from '../WinController';
import Game from '../../framework/src/game/slot/GameSlots';
import ISlots from '../../framework/src/game/slot/ISlots';
import GameFreespins from '../../framework/src/game/GameFreespins';
// import MadmaxPixiLayer from '../../framework/src/engine/pixi/MadmaxPixiLayer';
import { getSprite } from '../../framework/src/modules/Sprite';
import { EASE, getLoop, getTween, getTweenAsync,} from '../../framework/src/modules/Tween';
import { pixiClearTimeout, pixiSetTimeout, pixiSetTimeoutAsync } from '../../framework/src/engine/pixi/pixiTimeout';
import Board from './Board';
import { Frames } from '../Code/Frames';
import { getRandomBoolean, getRandomInt } from '../../framework/src/helpers';
import BigWin from './BigWin';


@injectable()
export default class FreeSpins {

    gameSet: SystemConfig;
    slots: ISlots;//GameSlotsCore;
    // layers: Record<string, MadmaxPixiLayer>;
    
    winController: WinController;
    bigWin: BigWin;
    
    board: Board;

    freeSpinBoard: PIXI.Sprite;
    freeSpinCount: PIXI.BitmapText;

    fireRopeList: Array<PIXI.AnimatedSprite> = [];
    fireScreen: PIXI.AnimatedSprite;
    fireText: PIXI.AnimatedSprite;
    freeSpinText: PIXI.Sprite;
    hideY: number = -110;

    audio: PixiAudio;

    screenCenter: { x: number, y: number } = { x: 0, y: 0 };

    freeSpinDataResult: any;

    gameFreeSpins: GameFreespins;

    lastWin: number;
    totalWin: number;
    wallet: Wallet;

    fsCounterSound: PixiAudio;
    fsMusic: PixiAudio; // pixiSound.Sound;
    fsMusicLoop: PixiAudio; // pixiSound.Sound;
    fsWinMusic: PixiAudio; // pixiSound.Sound;

    testAnimSprite : PIXI.AnimatedSprite;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,        
        @inject(SERVICE_IDENTIFIER.GameCore) core: GameSlotsCore,
        @inject(GAME_PARTS.WinController) WinController: WinController,        
        @inject(GAME_PARTS.BigWin) BigWin: BigWin,
        @inject(SERVICE_IDENTIFIER.Game) Game: Game,        
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: PixiAudio,        
    ) {
        this.gameSet = config["gameset"];

        this.audio = audio;

        this.screenCenter.x = this.gameSet["stageWidth"] / 2;
        this.screenCenter.y = this.gameSet["stageHeight"] / 2;

        this.slots = core.slots;
        this.winController = WinController;
        this.bigWin = BigWin;        

        this.freeSpinBoard = new PIXI.Sprite(PIXI.Texture.EMPTY);        

        this.gameFreeSpins = Game.freespins;
        this.wallet = wallet;
    }

    init(numberOfFires: number) {//fireArrayX: Array<number>, ropeY: number) {
        this.freeSpinBoard = getSprite('free-spins_background.png', 645, this.hideY, {x: 0.5, y: 0}); //640
        this.freeSpinBoard.name = "FreeSpin Board";

        let style: PIXI.IBitmapTextStyle = {
            fontName: "font_free_spins",
            fontSize: 72,
            align: "right",
            tint: 0xFFFFFF,
            letterSpacing: 0,
            maxWidth: 1280
        };

        this.freeSpinCount = new PIXI.BitmapText('0/0', style);
        this.freeSpinCount.name = "FreeSpin Count";        
        this.freeSpinCount.position.set( 106, -26 );
        this.freeSpinCount.anchor.set( .5 , 0 );
        this.freeSpinBoard.addChild(this.freeSpinCount);

        /*
         * fire rope list of animated sprites are added in
         * Commander.ts > addToIdleAnimation()
         *  to idle animation layer
         *  offset should fix animated sprite position inconsistence created by random orientation
         */
        do {
            let offset = -2;
            let tempFireRope = new PIXI.AnimatedSprite(Frames["ropeFire"]);
            tempFireRope.name = "FreeSpin FireRope_"+this.fireRopeList.length;            
            if (getRandomBoolean()) {
                offset *= -1;
                tempFireRope.scale.x = -1;
            }
            
            tempFireRope.visible = false;
            tempFireRope.loop = true;
            tempFireRope.animationSpeed = 0.33;  //0.25; ??? getRandomFloat() ???
            tempFireRope.anchor.set(0.5, 0);
            tempFireRope.position.x = offset;            
            this.fireRopeList.push(tempFireRope);

        } while (this.fireRopeList.length < numberOfFires)

        this.fireScreen = new PIXI.AnimatedSprite(Frames["screenFire"]);
        this.fireScreen.name = "FreeSpin Fire Screen";
        this.fireScreen.visible = false;
        this.fireScreen.loop = true;
        this.fireScreen.animationSpeed = 0.35; //0.30;
        this.fireScreen.anchor.set(0.5, 0.5);
        this.fireScreen.scale.set(1, 0.8);//(2.1, 0.9);
        this.fireScreen.position.set(687, 347);        

        this.fireText = new PIXI.AnimatedSprite(Frames["textFire"]);
        this.fireText.name = "FreeSpin Fire Text";
        this.fireText.visible = false;
        this.fireText.loop = true;
        this.fireText.animationSpeed = 0.30;
        this.fireText.anchor.set(0.5, 0.5);
        this.fireText.position.set(this.screenCenter.x, this.screenCenter.y);

        this.freeSpinText = getSprite("free-spins_text.png", 0, 0);
        this.freeSpinText.name = "FreeSpin Text Img";
        this.freeSpinText.visible = false;
        this.freeSpinText.alpha = 0;

        this.fireText.addChild(this.freeSpinText);
    }    

    /*
     * starting animation at the begining of free spins
     */
    async startingAnimation() {

        this.fireScreen.alpha = 0;
        this.fireScreen.visible = true;
        this.fireScreen.play();

        this.fireText.scale.set(0, 0);
        this.fireText.alpha = 1;
        this.fireText.visible = true;
        this.fireText.play();

        this.freeSpinText.alpha = 1;
        this.freeSpinText.visible = true;        

        getTweenAsync(this.fireScreen, { alpha: 1 }, 700, EASE.LINEAR);        
        getTweenAsync(this.fireScreen.scale, { x: 2.5, y: 1 }, 700, EASE.BACK_O);
        
        
        this.startRopesAnimation();
        
        this.audio.playTrack("bonus_FreeSpins_In");
        this.audio.playTrack("bg_FreeSpins_Start");
        pixiSetTimeoutAsync(5.4).then(() => {            
            this.audio.playTrack("bg_FreeSpins_Loop");
        });
        
        // this.freeSpinCount.text = "0/0";
        // this.freeSpinCount.pivot.x = this.freeSpinCount.width /2;
        this.updateFreeSpinCount(this.gameFreeSpins.getRoundNumber(), 0);
        this.showFreeSpinBoard();

        await getTweenAsync(this.fireText.scale, { x: 0.8, y: 0.8 }, 400, EASE.LINEAR);
        await getTweenAsync(this.fireText.scale, { x: 1, y: 1 }, 350, EASE.LINEAR); // EASE.BACK_O
        await getTweenAsync(this.fireText.scale, { x: 0.8, y: 0.8 }, 350, EASE.LINEAR);

        this.stopFireScreenAnimatin();
        await pixiSetTimeoutAsync(0.35);
        this.stopFireTextAnimation();
    }

    async stopFireScreenAnimatin(duration: number = 600) {
        await getTweenAsync(this.fireScreen, { alpha: 0 }, duration, EASE.LINEAR);
        this.fireScreen.alpha = 0;
        this.fireScreen.visible = false;
        this.fireScreen.stop();
        this.fireScreen.scale.set(0.8, 0.6);//(1,0.8);        
    }

    async stopFireTextAnimation() {        
        getTweenAsync(this.fireText.scale, { x: 2, y: 2 }, 350, EASE.LINEAR);
        await getTweenAsync(this.fireText, { alpha: 0 }, 350, EASE.LINEAR);

        this.fireText.alpha = 0;
        this.fireText.visible = false;
        this.fireText.stop();
        this.fireText.scale.set(0.8, 0.8);//(1,1);

        this.freeSpinText.alpha = 0;
        this.freeSpinText.visible = false;
    }

    async startRopesAnimation() {

        for (let fire of this.fireRopeList) {
            let offset = -2;    // hard coded offset distance
            let direction = 1;  // hard coded direction 

            if (getRandomBoolean()) {
                offset = 2;
                direction = -1;
            }

            fire.visible = true;
            getTweenAsync(fire, { alpha: 1 }, 100, EASE.LINEAR);
            fire.position.x = offset;
            fire.scale.x = direction;
            
            fire.gotoAndPlay(getRandomInt(0, Frames["ropeFire"].length - 1));             
        }
    }

    stopRopesAnimation() {
        for (let obj in this.fireRopeList) {
            getTween(this.fireRopeList[obj], { alpha: 0 }, 100, EASE.LINEAR);
            this.fireRopeList[obj].alpha = 0;
            this.fireRopeList[obj].stop();
            this.fireRopeList[obj].visible = false;
        }
    }

    async freeSpinBoardAnimateCount(maxFreeSpins: number) {
        
        if (!this.freeSpinBoard.visible) {
            console.error(this.showFreeSpinBoard());
        }
        
        for (let t = 0; t <= maxFreeSpins; t++) {            
            this.updateFreeSpinCount(this.gameFreeSpins.getRoundNumber(), t);            
            await pixiSetTimeoutAsync(0.1);
        }
    }

    async showFreeSpinBoard() {
        this.freeSpinBoard.renderable = true;
        this.freeSpinBoard.visible = true;
        await getTweenAsync(this.freeSpinBoard, { y: 0 }, 200, EASE.LINEAR);        
    }

    async hideFreeSpinBoard() {
        await getTweenAsync(this.freeSpinBoard, { y: this.hideY }, 200, EASE.LINEAR);
        this.freeSpinBoard.visible = false;
        this.freeSpinBoard.renderable = false;        
    }

    async toggleBoardOnWin() {
        if (this.freeSpinBoard.visible) {
            this.hideFreeSpinBoard();
        } else {
            this.showFreeSpinBoard();
        }
    }

    /*
     * ship line before the free spin starts
     */
    async startFreeSpin(result, index) {
        this.lastWin = 0;
        this.totalWin = this.wallet.moneyToCredit(result.getTotalWin());

        if (!this.winController.darkenBackground.alpha) {            
            this.winController.turnOnDarkBackground();            
        }

        if (index === result.lineWins.length - 1) {
            this.freeSpinDataResult = result.data.result;
        }

        let resultSymbols = this.slots.getResultSymbols();
        let promisList = [];
        let resultWins = result.lineWins[index];
        let symbolList = [];        
        
        promisList.push(this.winController.playSymbolAudio(resultWins.symbol, resultWins.type));
        //  !!!! line win on free spin ain't good !!!!
        for (let pos of resultWins.position) {
            
            let index = symbolList.push( resultSymbols[pos[0] * 3 + pos[1]] );
            index--;            
            
            this.winController.symbolLines.addChild( symbolList[index] );
            promisList.push( symbolList[index].create() );
            promisList.push( symbolList[index].play() );            
        }

        await Promise.all(promisList).then(async ()=>{
            for (let symb of  symbolList){
                await symb.clear();
            }
            symbolList.length = 0;
            promisList.length = 0;
        });
        
        if (this.winController.darkenBackground.alpha) {            
            this.winController.turnOffDarkBackground();
            this.winController.returnChildren();
        }

        // this.freeSpinCount.text = "0/0";
        await this.startingAnimation();        
        await this.freeSpinBoardAnimateCount(this.freeSpinDataResult.freeSpinNumber);        
        return result;
    }
   
    /**
     * update the counter for free spins
     * @param {number} roundN -- the number of the current round
     * @param {number} nOfRounds -- the number of all rounds (may be updated during game ?)
     */
    async updateFreeSpinCount( roundN : number , nOfRounds : number ) {
        
        this.audio.playTrack("bonus_FreeSpins_Counter");
        this.freeSpinCount.text = roundN.toString() + '/' + nOfRounds.toString();
    }

    async endFreeSpinMode() {        
        await this.hideFreeSpinBoard();
        this.bigWin.setBWScoreText(this.totalWin.toString());

        this.fireScreen.alpha = 0;
        this.fireScreen.play();
        this.fireScreen.visible = true;

        this.audio.fadeOutTrack("bg_FreeSpins_Loop", 200, true);        

        await this.bigWin.bigWinAnimation(true);

        getTweenAsync(this.fireScreen, { alpha: 1 }, 500, EASE.LINEAR);
        await getTweenAsync(this.fireScreen.scale, { x: 2.5, y: 1 }, 1000, EASE.BACK_O);
        this.stopRopesAnimation();

        await this.bigWin.bigWinFadeOut();

        await this.stopFireScreenAnimatin();

        pixiSetTimeoutAsync(7).then(() => {
            this.audio.fadeOutTrack("bwin_FreeSpins", 100, true);
        });       
    }

    destroyFreeSpins() {        
        
        this.bigWin = null;        

        this.freeSpinBoard = null;
        this.freeSpinCount = null;

        this.fireRopeList.length = 0;
        this.fireRopeList = null;

        this.fireScreen = null;
        this.fireText = null;
        this.freeSpinText = null;

        this.audio = null;

        this.screenCenter = null;

        this.freeSpinDataResult = null;

        this.gameFreeSpins = null;

        this.lastWin = null;
        this.totalWin = null;
        this.wallet = null;

        this.fsCounterSound = null;
        this.fsMusic = null; // pixiSound.Sound;
        this.fsMusicLoop = null; // pixiSound.Sound;
        this.fsWinMusic = null; // pixiSound.Sound;

        this.gameSet = null;
        this.slots = null;
        // this.layers = null;
    }
}
